
import { defineComponent, ref, computed, onUpdated, watch } from "vue";
import { useRoute } from "vue-router";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import ApiService from "@/core/services/ApiService";
import { hideModal } from "@/core/helpers/dom";

export default defineComponent({
  name: "edit-product-modal",
  emit: ["submit"],
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  props: {
    products: {
      type: Array,
      default: () => [
        {
          product_url: "",
          product_status: "On",
          purchase_type: "Free Trial",
          physical_product: "1",
        },
      ],
    },
    selectedIndex: { type: Number, required: true },
  },
  setup(props, { emit }) {
    onUpdated(() => {
      if (props.products.length > 0) {
        selectedProduct.value = Object.assign(
          {},
          props.products[props.selectedIndex]
        );
      }
    });

    const submitButton = ref<HTMLButtonElement | null>(null);
    const editProductModalRef = ref<HTMLElement | null>(null);

    // eslint-disable-next-line
    const selectedProduct = ref<any>({
      product_name: "",
      product_category: "",
      product_url: "",
      product_id: "",
      product_price: "",
      product_description: "",
      product_sku: "",
      product_status: "",
      fulfill_type: "",
      purchase_type: "",
      shipping_carrier: "",
      tax_class: "",
      shipping_tax: "",
      physical_product: "",
    });

    const route = useRoute();

    const product = Yup.object().shape({
      product_url: Yup.string().required().label("Image"),
      fulfill_type: Yup.string().required().label("FulFill type"),
      product_name: Yup.string().required().label("Name"),
      product_id: Yup.string().required().label("ID"),
      product_price: Yup.string().required().label("Price"),
      product_description: Yup.string().required().label("Description"),
    });

    const uploadLogo = async (evt) => {
      // eslint-disable-next-line
      const formData: any = new FormData();
      formData.append("upload", evt.target.files[0]);
      const res = await ApiService.post("imgupload", formData);
      if (res.data.success) {
        selectedProduct.value.product_url = res.data.data.url;
      }
    };

    const getMerchantId = computed(() => {
      return route.params.id;
    });

    const onSubmit = async () => {
      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // eslint-disable-next-line
      const payload: any = Object.assign([], props.products);
      payload.splice(props.selectedIndex, 1, selectedProduct.value);
      try {
        const res = await ApiService.put(
          `merchants/accounts/${getMerchantId.value}?merchantProduct`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "You have successfully updated the product!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            hideModal(editProductModalRef.value);
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    const onCancel = () => {
      selectedProduct.value = props.products[props.selectedIndex];
      hideModal(editProductModalRef.value);
    };

    return {
      uploadLogo,
      onSubmit,
      onCancel,
      product,
      submitButton,
      editProductModalRef,
      selectedProduct,
    };
  },
});
